"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var mockLegalEntity = {
    name: 'ACME',
    phone: '123456',
    email: 'acme@mail.com',
};
exports.default = mockLegalEntity;
//# sourceMappingURL=mockLegalEntity.js.map